import { forwardRef } from 'react';

import { Button } from '..';
import { TProps } from '../types/TProps';

export const TextButton = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <Button ref={ref} className={['btn--text', className].filter(Boolean).join(' ')} {...props} />
));

TextButton.displayName = 'TextButton';
